import { update as updateAc } from 'client/actions/entityActions'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useActions } from 'common/hooks/useActions'
import * as types from 'common/types'
import PropTypes from 'prop-types'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { Checkbox } from '../components'
import { Attributes, DelayOption, DeviceAppearance } from '../options'
import { getBackgroundStyles } from '../pages/components/BackgroundOld'
import {
  BackgroundPositionStyleNew,
  BorderStyleNew,
  CornerStyle,
  MarginsStyle,
  PaddingStyle,
  ShadowStyle,
} from '../styles'

const RowSettingsOld = props => {
  const {
    entity,
    updateStyle,
    updateMobileStyle,
    updateOption,
    updateMobileOption,
    update,
  } = props
  const { isMobile } = useDeviceModeContext()
  const updateAction = useActions(updateAc)

  const handleUpdateStyles = styles => {
    const entityMobileStyles = entity.mobileStyles ? entity.mobileStyles : {}
    const entityStyles = entity.styles ? entity.styles : {}
    const updatedEntity = { ...entity }
    if (updatedEntity.options.backgroundPosition) {
      delete updatedEntity.options.backgroundPosition
    }
    if (
      updatedEntity.mobileOptions &&
      updatedEntity.mobileOptions.backgroundPosition
    ) {
      delete updatedEntity.mobileOptions.backgroundPosition
    }
    if (isMobile) {
      updateAction({
        ...updatedEntity,
        mobileStyles: {
          ...entityMobileStyles,
          ...styles,
        },
      })
    } else {
      updateAction({
        ...updatedEntity,
        styles: {
          ...entityStyles,
          ...styles,
        },
      })
    }
  }
  const backgroundStyles = getBackgroundStyles(entity, isMobile)

  return (
    <React.Fragment>
      {/*<GroupTitle>entity_settings.row.column_space</GroupTitle>*/}
      {/*<Range*/}
      {/*  update={updateStyle('columnGap', 'px')}*/}
      {/*  value={entity.styles.columnGap}*/}
      {/*/>*/}
      <MarginsStyle
        marginTop={entity.styles.marginTop}
        marginRight={entity.styles.marginRight}
        marginBottom={entity.styles.marginBottom}
        marginLeft={entity.styles.marginLeft}
        mobileMarginTop={entity.mobileStyles.marginTop}
        mobileMarginRight={entity.mobileStyles.marginRight}
        mobileMarginBottom={entity.mobileStyles.marginBottom}
        mobileMarginLeft={entity.mobileStyles.marginLeft}
        update={updateStyle}
        mobileUpdate={updateMobileStyle}
      />
      <GroupTitle>color</GroupTitle>
      <ColorPickerControl
        label="bg color"
        update={updateStyle('backgroundColor')}
        mobileUpdate={updateMobileStyle('backgroundColor')}
        color={entity.styles.backgroundColor}
        mobileColor={entity.mobileStyles.backgroundColor}
      />
      <BackgroundPositionStyleNew
        fileId={
          isMobile
            ? entity.mobileOptions.backgroundFileId ||
              entity.options.backgroundFileId
            : entity.options.backgroundFileId
        }
        updateBackgroundFileId={
          isMobile
            ? updateMobileOption('backgroundFileId')
            : updateOption('backgroundFileId')
        }
        update={handleUpdateStyles}
        backgroundPosition={backgroundStyles}
      />
      <PaddingStyle
        mobilePadding={entity.mobileStyles.padding}
        padding={entity.styles.padding}
        update={updateStyle('padding')}
        mobileUpdate={updateMobileStyle('padding')}
      />
      <ShadowStyle
        shadow={entity.styles.boxShadow}
        mobileShadow={entity.mobileStyles.boxShadow}
        update={updateStyle('boxShadow')}
        mobileUpdate={updateMobileStyle('boxShadow')}
      />
      <BorderStyleNew entity={entity} />
      <CornerStyle
        topLeft={entity.styles.borderTopLeftRadius}
        topRight={entity.styles.borderTopRightRadius}
        bottomRight={entity.styles.borderBottomRightRadius}
        bottomLeft={entity.styles.borderBottomLeftRadius}
        mobileTopLeft={entity.mobileStyles.borderTopLeftRadius}
        mobileTopRight={entity.mobileStyles.borderTopRightRadius}
        mobileBottomLeft={entity.mobileStyles.borderBottomLeftRadius}
        mobileBottomRight={entity.mobileStyles.borderBottomRightRadius}
        update={updateStyle}
        mobileUpdate={updateMobileStyle}
      />
      <Checkbox
        helpMessage="entity_settings.row.disable_stacking.help_message"
        labelText="entity_settings.row.disable_stacking.label"
        value={entity.options.disableStacking}
        update={updateOption('disableStacking')}
      />
      <Checkbox
        labelText="entity_settings.row.reverse_columns.label"
        value={entity.options.reverseColumns}
        update={updateOption('reverseColumns')}
      />
      <DelayOption
        update={updateOption('delay')}
        delay={entity.options.delay}
      />
      <DeviceAppearance update={update} entity={entity} />
      <Attributes entity={entity} update={updateOption} />
    </React.Fragment>
  )
}

RowSettingsOld.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  updateStyle: PropTypes.func.isRequired,
  updateMobileStyle: PropTypes.func.isRequired,
  updateOption: PropTypes.func.isRequired,
  updateMobileOption: PropTypes.func.isRequired,
  entity: types.entity.isRequired,
  overlayVisible: PropTypes.bool.isRequired,
}

export default RowSettingsOld
